// Communications vocabulary (PROMPT 12)
export { TONE, optOf, labelOf, toneOf, prettify } from "@/config/tone";

export const COMM_TYPES = [
  { value: "call", label: "Phone call", tone: "navy", icon: "Phone" },
  { value: "email", label: "Email", tone: "sky", icon: "Mail" },
  { value: "live_chat", label: "Live chat", tone: "sky", icon: "MessageCircle" },
  { value: "portal_message", label: "Portal message", tone: "khaki", icon: "MessagesSquare" },
  { value: "in_person", label: "In-person meeting", tone: "green", icon: "Users" },
  { value: "zoom", label: "Zoom meeting", tone: "navy", icon: "Video" },
  { value: "other", label: "Other", tone: "gray", icon: "Megaphone" },
];

export const COMM_DIRECTIONS = [
  { value: "outbound", label: "Outbound", tone: "navy" },
  { value: "inbound", label: "Inbound", tone: "green" },
];

export const VISIBILITIES = [
  { value: "internal", label: "Internal only", tone: "gray" },
  { value: "family", label: "Family visible", tone: "green" },
  { value: "partner", label: "Partner visible", tone: "sky" },
  { value: "purchaser", label: "Purchaser visible", tone: "amber" },
];
